export { default } from './PaymentMethods';